module.exports = __webpack_public_path__ + "media/images/cheers_sent_success_4-0a9e0bdcdf87b07ce0b1d38ee7b1f47f.gif";